// import 'typeface-muli';
const colors = {
  black: '#000000',
  white: '#FFFFFF',
  tan: '#FFF5E6',
  tanMuted: '#969B9B',
  midTan: '#F7F5F2',
  muted: '#A1A1A1',
  coral: '#F0645A',
  purple: '#B04F7D',
  blue: '#5FC8EB',
  midBlue: '#22384F',
  yellow: '#FAC81E',
  grey: '#969B9B',
  greyLighter: '#979797',
  greyLight: '#EBEBEB',
  greyMid: '#d1d2cf',
  greyBorder: '#374a5b',
  green: '#5AD2A0',
  red: '#FF0000',
  chartPurple: '#A876E5',
  backgroundDark: '#18263A',
  backgroundMuted: '#1E3347',
  backgroundMutedMore: '#324F6E',
  backgroundInput: '#25425E',
  backgroundHighlight: '#203850',
  backgroundNotification: '#325A7D',
};

const themeColors = {
  primary: colors.coral,
  primaryLight: colors.coral,
  secondary: colors.purple,
  secondaryLight: colors.purple,
  error: colors.red,
};

const productCategoryColor = {
  isa: colors.yellow,
  pension: colors.purple,
  'pension-sub-plan': colors.purple,
  giagross: colors.purple,
  gia: colors.green,
  other: colors.white,
  bond: colors.blue,
  'bond-sub-plan': colors.blue,
};

const text = {
  primary: colors.tan,
  secondary: colors.tan,
  headerColor: colors.tan,
};

const font = {
  fontFamily: ['Roboto', 'sans-serif'],
  fontFamilySerif: ['TiemposHeadlineWeb', 'serif'],
};

const border = {
  borderRadius: 0,
  borderWidth: '1px',
  borderColor: colors.grey,
  borderColorSelected: colors.blue,
  borderColorDisabled: colors.grey,
};

const button = {
  borderWidth: '2px',
  borderColor: colors.greyDark,
  boxShadow: 'none',
  backgroundColorActive: colors.greyDark,
  backgroundColorDisabled: colors.grey,
  colorActive: colors.grey,
};

const background = {
  backgroundColor: colors.backgroundBlueDark,
  backgroundColorMuted: colors.backgroundBlueMuted,
  boxShadow: 'none',
};

const input = {
  borderRadius: border.borderRadius,
  borderWidth: border.borderWidth,
  borderWidthDisabled: border.borderWidth + 1,
  borderColor: border.borderColor,
  borderColorSelected: border.borderColorSelected,
  borderColorDisabled: border.borderColorDisabled,
  backgroundColor: colors.white,
  backgroundColorDisabled: colors.grey,
  colorDisabled: colors.white,
};

const stepper = {
  color: colors.grey,
  colorActive: colors.green,
  colorComplete: colors.green,
};

const variables = {
  background,
  border,
  button,
  colors,
  font,
  input,
  productCategoryColor,
  stepper,
  text,
  themeColors,
};

export default variables;
